import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFollowedStores as fetchFollowedStoresService } from "./followed-stores.service";
import { FollowedStoresResponse, GetFollowedStoresRequest } from "./followed-stores.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getFollowedStores = createAsyncThunk<
  FollowedStoresResponse,
  GetFollowedStoresRequest | undefined,
  { rejectValue: string }
>("followedStores/getFollowedStores", async (params, { rejectWithValue }) => {
  try {
    const response = await fetchFollowedStoresService(params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});